import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-secondary-100/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-2 h-2 rounded-full bg-accent-500"></div>
          <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">
            {t('testimonials.tag')}
          </span>
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
          {t('testimonials.title')}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10">
          {t('testimonials.subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((testimonial, idx) => (
            <div
              key={testimonial.name}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/50 transition-all duration-300 hover:border-accent-200/50 ${
                idx >= 3 ? 'opacity-70 hover:opacity-100' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < testimonial.rating
                        ? 'ri-star-fill text-amber-400'
                        : 'ri-star-line text-background-300'
                    }`}
                  ></i>
                ))}
              </div>

              <h4 className="text-sm font-semibold text-foreground-900 mb-2">
                {testimonial.title}
              </h4>

              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {testimonial.text}
              </p>

              <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-foreground-500">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}